import { ERROR_FETCH_ECONSENT, START_FETCH_ECONSENT, SUCCESS_FETCH_ECONSENT } from 'login-actions/actionTypes';

const initialState = {
  fetching: false,
  success: false,
  error: null,
  content: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_FETCH_ECONSENT:
      return { ...state, success: true, error: null, fetching: false, content: action.payload };
    case ERROR_FETCH_ECONSENT:
      return { ...state, success: false, error: action.payload, fetching: false, content: null };
    case START_FETCH_ECONSENT:
      return { ...state, success: false, error: null, fetching: true, content: null };
    default:
      return state;
  }
};
